module.exports = __webpack_public_path__ + "img/join_02.e991ce92.png";